import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const currentLanguage = i18n.language.split('-')[0]; // Handle cases like 'en-US'

    return (
        <div className="flex items-center gap-1.5 px-2">
            <div className="w-8 h-8 bg-indigo-50 rounded-lg flex items-center justify-center text-indigo-600 flex-shrink-0">
                <Globe size={16} />
            </div>
            <div className="flex bg-gray-100 p-0.5 rounded-lg flex-1 w-20">
                <button
                    onClick={() => changeLanguage('en')}
                    className={`flex-1 py-1.5 rounded-md text-[10px] font-black transition-all ${currentLanguage === 'en'
                        ? 'bg-white text-indigo-600 shadow-sm'
                        : 'text-gray-400 hover:text-gray-600'
                        }`}
                >
                    EN
                </button>
                <button
                    onClick={() => changeLanguage('fr')}
                    className={`flex-1 py-1.5 rounded-md text-[10px] font-black transition-all ${currentLanguage === 'fr'
                        ? 'bg-white text-indigo-600 shadow-sm'
                        : 'text-gray-400 hover:text-gray-600'
                        }`}
                >
                    FR
                </button>
            </div>
        </div>
    );
};

export default LanguageSwitcher;
